
import { MarketingLabel } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'


interface BadgeProps {
  data: MarketingLabel;
}

export default function Badge (props: BadgeProps) {
  const { data } = props
  return (
    <span
      className={cn(styles.root)}
      style={{
        backgroundColor: data.optionBackgroundColor as string,
        color: data.optionColor as string,
      }}
    >
      {data.image?.url && (
        <img
          className={styles.root__img}
          src={data.image.url as string}
          loading="lazy"
          fetchPriority="low"
        />
      )}

      {data.title}
    </span>
  )
}
